// src/components/Layout.tsx
import React from 'react';
import { Box } from '@mui/material';
import Header from './components/header';
import Footer from './components/footer';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh'}}>
      <Header />
      <Box component="main" sx={{ flex: 1}}>
        {children}
      </Box>
      <Footer />
    </Box>
  );
};

export default Layout;